import { BaseService } from './BaseService';

export interface NotificationLogDto {
  id: string;
  tenantId: string;
  projectId: string | null;
  notificationType: number;
  subject: string;
  htmlBody: string;
  recipients: string;
  status: number;
  errorMessage: string | null;
  sentAt: string;
}

export interface NotificationLogPageDto {
  items: NotificationLogDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

const NOTIFICATION_TYPE_LABELS: Record<number, string> = {
  0: 'Budget Alert',
  1: 'Key Rotation',
  2: 'Security Alert',
  3: 'System Update',
};

const NOTIFICATION_STATUS_LABELS: Record<number, string> = {
  0: 'Pending',
  1: 'Sent',
  2: 'Failed',
};

export const getNotificationTypeLabel = (type: number) =>
  NOTIFICATION_TYPE_LABELS[type] ?? `Type ${type}`;

export const getNotificationStatusLabel = (status: number) =>
  NOTIFICATION_STATUS_LABELS[status] ?? `Status ${status}`;

export class NotificationService extends BaseService {
  async getNotifications(
    tenantId: string,
    page: number = 1,
    pageSize: number = 20,
    projectId?: string,
    type?: number,
  ): Promise<NotificationLogPageDto> {
    const params = new URLSearchParams({ tenantId, page: page.toString(), pageSize: pageSize.toString() });
    if (projectId) params.append('projectId', projectId);
    if (type !== undefined) params.append('type', type.toString());
    return this.get<NotificationLogPageDto>(`/notifications?${params}`);
  }

  async getNotification(id: string): Promise<NotificationLogDto> {
    return this.get<NotificationLogDto>(`/notifications/${id}`);
  }
}

export const notificationService = new NotificationService();
